import { UpDownNavigation } from '../Shared/keyboard_navigation.js';

onDomReady(function() {
   var embedAdded = false;

   function getEmbedHtml(width, type) {
      var height = Math.floor(width * window.shared_constants.Global('EMBED_ASPECT_RATIO'));
      var textarea = $$('.js-embed-' + type + '.js-embed-text')[0];
      var embedHtml = textarea.get('data-embed-template').replace('{width}', width);

      if (type == 'single') {
         embedHtml = embedHtml.replace('{height}', height);
      }

      return embedHtml;
   }

   var swapImage = function(thumbDiv, mediaDiv) {
      thumbDiv
         .getParent('.js-step')
         .getElements('.js-step-thumbnail-container')
         .removeClass('active');

      thumbDiv.addClass('active');

      var newLargeImage = $(thumbDiv.getAttribute('data-fullimg'));
      var oldLargeImage = mediaDiv.getElement('img.visible');
      // If newLargeImage isn't an <img> or oldLargeImage doesn't exist
      // we shouldn't do swapping as lazy-loading hasn't happened
      if (!newLargeImage.src || !oldLargeImage) {
         return;
      }

      oldLargeImage.removeClass('visible');
      newLargeImage.addClass('visible');

      // Disable the old menu and enable the new one. Note that on page load,
      // only the first image gets a menu installed, so for the other images we
      // need to create a new menu on the first view.
      var menu = ImageMenu.getMenu(oldLargeImage);
      if (menu) {
         menu.disable();
         menu = ImageMenu.getMenu(newLargeImage);
         if (!menu) {
            menu = ImageMenu.installMenu(newLargeImage);
            newLargeImage.addClass('hasMenu');
         }
         menu.enable();
      }
   };

   function toggleStepComments(stepContainer, duration, show) {
      duration = duration !== undefined ? duration : 0.5;

      var expandingContainer = stepContainer.getElement('.comments-container');
      const manager = getCommentManager(stepContainer);

      // If the caller didn't specify whether to show (show === true) or hide
      // (show === false) then toggle the comment from its current state.
      if (show === undefined) {
         show = expandingContainer.hasClass('closed');
      }

      if (expandingContainer) {
         if (!show) {
            TweenMax.to(expandingContainer, duration, {
               height: 0,
               opacity: 0,
               ease: Expo.easeOut,
               onComplete: function() {
                  expandingContainer.addClass('closed');
               },
            });
         } else {
            manager.loadComments().then(function() {
               TweenMax.set(expandingContainer, { height: 'auto' });
               TweenMax.set(expandingContainer, { opacity: 1 });
               TweenMax.from(expandingContainer, duration, {
                  height: 0,
                  opacity: 0,
                  ease: Expo.easeOut,
                  onComplete: function() {
                     expandingContainer.removeClass('closed');
                  },
               });
            });
         }
      }
   }

   function getCommentManager(stepContainer) {
      const commentContainer = stepContainer.getElement('.js-comment-container');
      let manager = commentContainer.retrieve('commentManager');
      if (!manager) {
         manager = new CommentManager(commentContainer);
         commentContainer.store('commentManager', manager);
      }
      return manager;
   }

   function updateEmbedHtml(ev, el) {
      var checkClearClass,
         $this = $(this);

      if ($this.hasClass('js-embed-width')) {
         checkClearClass = 'js-embed-width';
      } else {
         checkClearClass = 'js-embed-type';
      }

      $$('.js-button-checkable.' + checkClearClass).removeClass('button-checked');
      $this.addClass('button-checked');

      var width = $$('.js-embed-width.button-checked')[0].get('data-embedWidth'),
         type = $$('.js-embed-type.button-checked')[0].get('data-embedType'),
         embedHtml = getEmbedHtml(width, type),
         textarea = $$('.js-embed-text')[0];

      $$('.js-embed-single').hide();
      $$('.js-embed-full').show();

      $('embedBoxIframe').set('html', embedHtml);

      textarea.set('value', embedHtml);
      textarea.select();
   }

   // Handle hash fragments that refer to hidden comments
   onHashFragmentElement(function(comment) {
      // Comments within steps are hidden by default
      var stepContainer = comment.getParent('.js-step');

      if (stepContainer) {
         toggleStepComments(stepContainer, 0, true);

         // Wait until the page loads so that the scroll position can be
         // calculated.
         onLoad(function() {
            comment.jumpTo({
               offset: 0,
               duration: 0,
            });
         });
      }
   });

   $$('.js-step').each(function(step) {
      var mainImg = step.getElement('.js-step-main-media');
      step.getElements('.js-step-thumbnail-container').each(function(thumb) {
         var swapImageWrap = swapImage.pass([thumb, mainImg]);
         thumb.addEvents({
            mouseenter: swapImageWrap,
            click: swapImageWrap,
         });
      });
   });

   // For guide images
   var showLargeImage = function(imageDiv, ev) {
      // Don't do anything if the target of the click wasn't the image.
      if ($(ev.target).get('tag') != 'img') {
         return;
      }
      // Don't try to show a large image for the "no image" image.
      if (imageDiv.hasClass('noImage') || $(ev.target).hasClass('js-no-link')) {
         return;
      }

      // Find the largest size available.
      var img = imageDiv.getElement('img.visible'),
         largest = img && img.get('data-biggest');

      if (largest) {
         window.open(largest, '_blank');
      }
   };

   $$('.js-step .stepMedia.stepImage').each(function(mediaDiv) {
      mediaDiv.addEvent('click', showLargeImage.bind(null, mediaDiv));
   });

   $$('.js-share-dropdown').each(function(el) {
      var url = encodeURIComponent(App.canonical);
      var title = encodeURIComponent(App.page_title);
      new ButtonDropdown(el, {
         items: [
            {
               title: _js('Embed this guide'),
               href: '#',
               icon: 'code',
               class: 'js-show-embed',
            },
            {
               title: 'Facebook',
               href: 'https://www.facebook.com/sharer.php?u=' + url + '&t=' + title,
               icon: 'facebook-f',
               class: '',
            },
            {
               title: 'Twitter',
               href: 'https://twitter.com/intent/tweet?text=' + title + '&url=' + url,
               icon: 'twit',
               class: '',
            },
         ],
      });
   });

   $$('.js-step .js-comment-container').each(function(el) {
      // Attach a CommentManager to every open comments section. Closed
      // comment sections will get a CommentManager when they are opened.
      if (el.getElement('.comments-container:not(.closed)')) {
         el.store('commentManager', new CommentManager(el));
      }
   });

   ContentDropdownGroup($$('.js-guide-details-container'));

   $$('.item-list li a').each(function(li) {
      new ItemHover(li);
   });

   $$('.publish-guide-banner').each(function(banner) {
      var guideid = banner.getProperty('data-guideid');
      var revisionid = banner.getProperty('data-guide-api-revisionid');
      var status = new StatusNotice(banner.getElement('.status'));

      banner.getElements('.button').addEvent('click', function() {
         var url = 'guides/' + guideid + '/public?revisionid=' + revisionid;
         new Request.API_2_0(url, {
            method: 'put',
            onFailure: function(xhr) {
               var response = JSON.decode(xhr.response);
               var msg = _js('Unable to publish guide.');
               if (response && response.message) {
                  msg = response.message;
               }
               status.error(msg);
               status.addCloseButton();
            },
            onSuccess: function(response) {
               status.good(_js('Successfully published.'));
               status.addCloseButton();
               window.location.reload();
            },
         }).send();
      });
   });

   window.addEvents({
      'click:relay(.js-screen-size-item)': function(ev, el) {
         var size = el.get('data-screen-size');
         $$('.js-video-container').set('data-video-size', size);
         $$('.js-screen-size-item').removeClass('active');
         el.addClass('active');
      },
      'click:relay(.js-show-comments)': function(ev, el) {
         var stepContainer = el.getParent('.js-step');
         toggleStepComments(stepContainer);
      },
      'click:relay(.js-expand-comments)': function(ev, el) {
         var stepContainers = $$('.js-step').filter(function(item) {
            return item.getElement('button.js-comment-count').get('data-numcomments') > 0;
         });
         var expand = !el.getElement('.expand').hasClass('hidden');

         SettingsCookie.set('expand-comments', expand.toString());

         stepContainers.each(function(stepContainer) {
            toggleStepComments(stepContainer, 0, expand);
         });

         el.getElements('.expand, .collapse').toggleClass('hidden');
      },
      'click:relay(.js-embed-type.js-button-checkable)': updateEmbedHtml,
      'click:relay(.js-embed-width.js-button-checkable)': updateEmbedHtml,
      'click:relay(.js-show-embed)': function(ev, el) {
         var embedBox = $('embedBox');
         if (embedBox && !embedAdded) {
            embedAdded = true;
            embedBox.appendHTML(
               '<div id="embedBoxIframe">' + getEmbedHtml(800, 'single') + '</div>'
            );
         }

         Modal.open({
            type: 'element',
            element: embedBox,
            onLoad: function(content) {
               var textarea = content.getElement('.js-embed-text');
               if (textarea) {
                  textarea.select();
               }
            },
         });
      },
      'click:relay(.js-show-shareable-link)': function(ev, el) {
         var modalEl = new Element('div.shareable-link-container').grab(
            new Element('h3', {
               text: _js('Shareable Link'),
            })
         );

         var modalInput = new Element('input', {
            type: 'text',
            value: el.get('data-shareable-link'),
         }).inject(modalEl);

         Modal.open({
            type: 'element',
            element: modalEl,
         });

         modalInput.select();
      },
      'click:relay(.js-subscribe-edit)': function() {
         Auth.required({
            from: $$('.js-subscribe-edit'),
            message: _js('Log in to subscribe.'),
            onAuthorize: LoadingIndicator.withEventHandler(
               function(ev, el) {
                  var guideid = App.guideid;
                  var langid = App.viewLangid;
                  var url =
                     'subscribe/' +
                     window.guide_constants.DocumentWatch('DOCTYPE_GUIDE') +
                     '/' +
                     guideid +
                     '/' +
                     langid +
                     '/' +
                     window.guide_constants.DocumentWatch('LEVEL_EDIT');
                  if ($$('.js-subscribe-edit')[0].hasClass('unsubscribed')) {
                     return new Request.API_2_0(url, {
                        method: 'put',
                        onSuccess: function(response) {
                           $$('.js-subscribe-edit')
                              .removeClass('unsubscribed')
                              .addClass('subscribed');
                        },
                     }).send();
                  } else {
                     return new Request.API_2_0(url, {
                        method: 'delete',
                        onSuccess: function(response) {
                           $$('.js-subscribe-edit')
                              .removeClass('subscribed')
                              .addClass('unsubscribed');
                        },
                     }).send();
                  }
               },
               {
                  pendingMessage: _js('Updating Subscription'),
                  successMessage: _js('Success'),
                  failureMessage: _js('Failure'),
               }
            ),
         });
      },
   });

   var upDownNav = new UpDownNavigation({
      items: $$('.js-step'),
      onBeforejump: function() {
         var context = 8;
         var notifications;
         if ((notifications = $('notifications'))) {
            context += notifications.getSize().y;
         }
         upDownNav.options.scrollContext = context;
      },
   });

   when($$('.time-travel .dropdown-wrapper'), function(dropdown) {
      dropdown.addEvent('valuechanged', function() {
         var targetRevision = this.getValue();
         var url = new URI(window.location.href);
         url.setData({ revisionid: targetRevision }, /* merge */ true).go();
      });
   });
});
